<template>
  <scoped>
    <label
      v-if="title"
      :for="id"
    >
      {{ title }}
    </label>
    <input
      v-if="!multiline"
      :id="id"
      v-model="value"
      type="text"
      :disabled="readOnly"
    >
    <textarea
      v-if="multiline"
      :id="id"
      v-model="value"
      rows="5"
      :disabled="readOnly"
    />
  </scoped>
</template>

<script setup lang="ts">
  import {useId} from "vue"

  defineProps({
    multiline: {
      default: false,
      required: false,
      type: Boolean
    },
    readOnly: {
      default: false,
      required: false,
      type: Boolean
    },
    title: {
      default: null,
      required: false,
      type: String
    }
  })

  const id = useId()
  const value = defineModel("value", {
    default: null,
    required: true,
    type: String
  })
</script>

<style scoped>
  input[type = "text"], textarea {
    background-color: var(--color-white);
    border-color: var(--theme-color-primary);
    border-radius: var(--border-radius-small);
    border-style: solid;
    border-width: var(--border-width-light);
    display: block;
    margin: 0.5em 0;
    padding: 0.5em;
    resize: none;

    &:focus, &:hover {
      border-color: var(--color-grey);
    }
  }

  label {
    display: block;
    font-weight: bolder;
  }
</style>
